import { Helmet } from "react-helmet-async";

const Inspectlet = () => {

    let inspectletKey = process.env.REACT_APP_INSPECTLET_KEY;
    if (!inspectletKey) {
        return <></>
    }

    return (
        <Helmet>
            <script type="text/javascript">{`
                (function() {
                    window.__insp = window.__insp || [];
                    __insp.push(['wid', ${inspectletKey}]);
                    var ldinsp = function(){
                        if(typeof window.__inspld != "undefined")
                            return;
                        window.__inspld = 1;
                        var insp = document.createElement('script');
                        insp.type = 'text/javascript';
                        insp.async = true;
                        insp.id = "inspsync";
                        insp.src = ('https:' == document.location.protocol ? 'https' : 'http') + '://cdn.inspectlet.com/inspectlet.js?wid=${inspectletKey}&r=' + Math.floor(new Date().getTime()/3600000);
                        var x = document.getElementsByTagName('script')[0]; x.parentNode.insertBefore(insp, x); 
                    };
                    setTimeout(ldinsp, 0);
                })();
            `}</script>

        </Helmet>
    );
};

export default Inspectlet;
